import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import AddRole from '../pages/roles/components/AddRole'
import RolesList from '../pages/roles/components/RolesList'
import EditRole from '../pages/roles/components/EditRole'
import AddAdmin from '../pages/admins/components/AddAdmin'
import AdminsList from '../pages/admins/components/AdminsList'
import ChangePassword from '../pages/layout-builder/ChangePassword'
import AddApplication from '../pages/applications/components/AddApplication'
import ApplicationsList from '../pages/applications/components/ApplicationsList'
import EditApplication from '../pages/applications/components/EditApplication'
import ActiveUsersApplicationsList from '../pages/users-applications/components/ActiveUsersApplicationsList'
import InactiveUsersApplicationsList from '../pages/users-applications/components/InactiveUsersApplicationsList'
import ViewApplicationDetails from '../pages/users-applications/components/ViewApplicationDetails'
import { ProfileHeader } from '../modules/profile/ProfileHeader'
import { permissionCheck } from '../helper-functions/PermissionCheck'
import UsersList from '../pages/owner-users/components/UsersList'
import ViewOwnerUserDetail from '../pages/owner-users/components/ViewOwnerUserDetail'
import RolesLogs from '../pages/roles/components/RolesLogs'
import RoleLogs from '../pages/roles/components/RoleLogs'
import AllAdminLogs from '../pages/admins/components/AllAdminLogs'
import SingleAdminLog from '../pages/admins/components/SingleAdminLog'
import ApplicationLogs from '../pages/applications/components/ApplicationLogs'
import ApplicationsLogs from '../pages/applications/components/ApplicationsLogs'
import UserApplicationsLogs from '../pages/users-applications/components/UserApplicationsLogs'
var user_create,user_update,user_delete,user_view, user_activity_log
var role_create,role_update,role_delete,role_view,role_activity_log
var application_create,application_update,application_delete,application_view,application_activity_log
var user_application_create,user_application_update,user_application_delete,user_application_view,user_application_activity_log
const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
user_create = permissionCheck('user-create');
  user_update = permissionCheck('user-update');
  user_delete = permissionCheck('user-delete');
  user_view = permissionCheck('user-view');
  user_activity_log = permissionCheck('user-activity-log');
  role_create = permissionCheck('role-create');
  role_update = permissionCheck('role-update');
  role_delete = permissionCheck('role-delete');
  role_view = permissionCheck('role-view');
  role_activity_log = permissionCheck('role-activity-log');
  application_create = permissionCheck('application-create');
  application_update = permissionCheck('application-update');
  application_delete = permissionCheck('application-delete');
  application_view = permissionCheck('application-view');
  application_activity_log = permissionCheck('application-activity-log');
  user_application_create = permissionCheck('user-application-create');
  user_application_update = permissionCheck('user-application-update');
  user_application_delete = permissionCheck('user-application-delete');
  user_application_view = permissionCheck('user-application-view');
  user_application_activity_log = permissionCheck('user-application-activity-log');
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />       
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='/profile' element={<ProfileHeader />} />
       {
        application_create &&( <Route path="/applications/add-application" element={<AddApplication />} /> )
       }         
       {
        application_view && ( <Route path="/applications/applications-list" element={<ApplicationsList />} />)
       }  
        {
          application_update &&( <Route path="/applications/edit-application" element={<EditApplication />} />)
        }    
        {
          1 &&( <Route path="/applications/activity-log" element={<ApplicationLogs />} />)
        }    
        {
          application_view &&( <Route path="/applications/applications-logs" element={<ApplicationsLogs />} />)
        }    
        {
          role_create && (
            <Route path="/roles/add-role" element={<AddRole />} />   
          )
        }
        {
          user_application_view && (
            <Route path="/user-applications/active" element={<ActiveUsersApplicationsList />} />
          )
        }   
        {
          user_application_view && (
            <Route path="/user-applications/inactive" element={<InactiveUsersApplicationsList />} /> 
          )
        }
        {
          user_application_view && (
            <Route path="/user-applications/view-application-details" element={<ViewApplicationDetails />} />
          )
        }   
        {
          user_application_view && (
            <Route path="/user-applications/activity-logs" element={<UserApplicationsLogs />} />
          )
        }   
        {
          role_view && (
            <Route path="/roles/roles-list" element={<RolesList />} />  
          )
        }
        {
          role_activity_log && (
            <Route path="/roles/logs" element={<RolesLogs />} />  
          )
        }
        {
          role_activity_log && (
            <Route path="/roles-list/role-logs" element={<RoleLogs />} />  
          )
        }
        {
          role_update && (
            <Route path="/roles/edit-role" element={<EditRole />} /> 
          )
        }  
        {
          user_create && (
            <Route path="/admins/add-admin" element={<AddAdmin />} /> 
          )
        }
        {
          user_view &&(
            <Route path="/admins/admins-list" element={<AdminsList />} /> 
          )
        } 
        {
          user_activity_log &&(
            <>
            <Route path="/admins/all-logs" element={<AllAdminLogs/>} /> 
            <Route path="/admins/log" element={<SingleAdminLog/>} /> 
            </>
          )
        } 
        {
          user_view &&(
            <>
            <Route path="/owner-users/list-users" element={<UsersList />} />
            <Route path="/owner-users/view-owner-user" element={<ViewOwnerUserDetail/>} />
            </> 
          )
        } 
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />        
        <Route path="/change-password" element={<ChangePassword />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
